module.exports = window["wp"]["components/src/spinner/index"];